import React from 'react';

export default {
  Layout: (props) => (
    <div style={{ 
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      height: '100%' 
    }}>{props.children}</div>
  ),

}